import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelText as _vModelText, resolveDirective as _resolveDirective, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../assets/images/chat/send.svg'


const _hoisted_1 = { class: "border-white select-profile h-100 overflow-hidden" }
const _hoisted_2 = { class: "d-flex align-items-center py-2 px-3 text-black font-size-md header-custom-border" }
const _hoisted_3 = { class: "input-group px-3 py-2" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" })
  ])
], -1 /* HOISTED */)
const _hoisted_6 = { class: "height-80" }
const _hoisted_7 = {
  key: 0,
  class: "form-group"
}
const _hoisted_8 = { class: "form-check custom-checkbox mx-3 pt-2 pb-1" }
const _hoisted_9 = ["id", "value"]
const _hoisted_10 = ["for"]
const _hoisted_11 = { class: "mx-4 px-3 pb-2" }
const _hoisted_12 = {
  key: 0,
  class: "d-flex font-size-sm"
}
const _hoisted_13 = { class: "me-2 patient-mrn" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold" }, "MRN: ", -1 /* HOISTED */)
const _hoisted_15 = { class: "text-capitalize" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold" }, "| Status: ", -1 /* HOISTED */)
const _hoisted_17 = { class: "pt-1" }
const _hoisted_18 = {
  class: "text-default font-size-xs ms-2",
  style: {"margin-top":"2px"}
}
const _hoisted_19 = {
  key: 0,
  class: "py-1"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "loader-parent" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "msg-loader" })
], -1 /* HOISTED */)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 1,
  class: "text-center font-size-md py-2"
}
const _hoisted_23 = {
  key: 1,
  class: "d-flex flex-column h-100 align-items-center justify-content-center loading"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "loading_modal" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-heart heartbeat" }),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "LOADING")
], -1 /* HOISTED */)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 2,
  class: "error-state"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Please try again.")
const _hoisted_29 = {
  key: 0,
  class: "mt-auto ps-3 pt-1 d-flex w-100 height-10 align-items-center send-footer"
}
const _hoisted_30 = {
  class: "selected-names-scroll",
  ref: "selectedNamesScroll"
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "send-btn-wrapper" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
const _hoisted_35 = [
  _hoisted_34
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductPill = _resolveComponent("ProductPill")!
  const _component_ScrollPagination = _resolveComponent("ScrollPagination")!
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _withDirectives(_createElementVNode("span", { class: "fw-bold" }, " Share " + _toDisplayString(_ctx.capitalizeFirstLetter(_ctx.profileType)) + " Profile ", 513 /* TEXT, NEED_PATCH */), [
        [_vShow, _ctx.profileType]
      ]),
      _createElementVNode("i", {
        class: "ms-auto fas fa-times-circle grey-secondary-text cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancel()))
      })
    ]),
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          placeholder: _ctx.getSearchPlaceholder,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event))
        }, null, 8 /* PROPS */, _hoisted_4), [
          [_vModelText, _ctx.search],
          [_directive_focus]
        ]),
        _hoisted_5
      ])
    ], 32 /* HYDRATE_EVENTS */),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_ScrollPagination, {
        class: "content-y height-90",
        "page-number": _ctx.pageNumber,
        "all-pages-loaded": _ctx.allPagesLoaded,
        "is-loading": _ctx.loadMore,
        "has-error": _ctx.hasError,
        onPageNumberUpdate: _ctx.pageNumberUpdated
      }, {
        default: _withCtx(() => [
          _createElementVNode("section", {
            class: _normalizeClass(["d-flex flex-column overflow-auto h-100 flex-nowrap scroll-paginate", `${_ctx.userOs == 'Windows' ? 'custom-scrollbar' : ''}`])
          }, [
            (!_ctx.isLoading && !_ctx.hasError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_ctx.lists.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lists, (list) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "custom-border-bottom test-class",
                            key: list.id
                          }, [
                            _createElementVNode("div", _hoisted_8, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input test",
                                type: "checkbox",
                                name: "advance_care",
                                id: `${
                                            _ctx.profileType == _ctx.SelectProfileEnum.Employee
                                                ? list.sourceUserId
                                                : list.patientId
                                        }`,
                                value: list,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedOptions) = $event))
                              }, null, 8 /* PROPS */, _hoisted_9), [
                                [_vModelCheckbox, _ctx.selectedOptions]
                              ]),
                              _createElementVNode("label", {
                                class: "form-check-label fw-bold",
                                for: `${
                                            _ctx.profileType == _ctx.SelectProfileEnum.Employee
                                                ? list.sourceUserId
                                                : list.patientId
                                        }`
                              }, _toDisplayString(_ctx.capitalizeFirstLetter(list.lastName + " " + list.firstName)), 9 /* TEXT, PROPS */, _hoisted_10)
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                              (_ctx.profileType == _ctx.SelectProfileEnum.Patient)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("span", _hoisted_13, [
                                      _hoisted_14,
                                      _createTextVNode(_toDisplayString(list.mrn), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("span", _hoisted_15, [
                                      _hoisted_16,
                                      _createTextVNode(_toDisplayString(list.status === _ctx.PatientStatusEnum.nonadmitted
                                                    ? "Non-Admit"
                                                    : _ctx.PatientStatus.getDescriptionUsingValue(list.status)), 1 /* TEXT */)
                                    ])
                                  ]))
                                : _createCommentVNode("v-if", true),
                              _createElementVNode("div", _hoisted_17, [
                                _createVNode(_component_ProductPill, {
                                  class: "application-name",
                                  "product-id": _ctx.getApplicationId(list.application)
                                }, null, 8 /* PROPS */, ["product-id"]),
                                _createElementVNode("span", _hoisted_18, _toDisplayString(list.agencyName), 1 /* TEXT */)
                              ])
                            ])
                          ]))
                        }), 128 /* KEYED_FRAGMENT */)),
                        (_ctx.loadMore)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                          : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock("div", _hoisted_22, "No Matches Found"))
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" WAITING "),
            (_ctx.isLoading && !_ctx.hasError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_23, _hoisted_25))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" ERROR "),
            (_ctx.hasError && !_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("p", null, [
                    _createTextVNode("There was a problem while fetching your " + _toDisplayString(_ctx.profileType) + ".", 1 /* TEXT */),
                    _hoisted_27,
                    _hoisted_28
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (
                                `${
                                    _ctx.profileType == _ctx.SelectProfileEnum.Employee ? _ctx.getUsersList('') : _ctx.fetchPatientsList('')
                                }`
                            ))
                  }, " Try Again ")
                ]))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["page-number", "all-pages-loaded", "is-loading", "has-error", "onPageNumberUpdate"]),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createCommentVNode(" Scrollable selected names "),
            _createElementVNode("div", _hoisted_30, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedOptions, (selectedOption, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: selectedOption.id,
                  class: "blue-text selected-name"
                }, [
                  _createTextVNode(_toDisplayString(_ctx.capitalizeFirstLetter(selectedOption.lastName + " " + selectedOption.firstName)) + " ", 1 /* TEXT */),
                  (index < _ctx.selectedOptions.length - 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, ", "))
                    : _createCommentVNode("v-if", true)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("button", {
                class: "btn border-0 pt-0",
                disabled: _ctx.selectedOptions.length === 0,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateSelectedItems()))
              }, _hoisted_35, 8 /* PROPS */, _hoisted_33)
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}